import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { ProductivityIconPipe } from '@wilson/shift-timeline/pipes';
import { DateTimeFormat } from '@wilson/utils';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TimelineTimeframe } from '@wilson/interfaces';

@Component({
  selector: 'wilson-productivity-kpi',
  imports: [
    CommonModule,
    NzTooltipModule,
    TranslateModule,
    NzSkeletonModule,
    ProductivityIconPipe,
    FontAwesomeModule,
  ],
  templateUrl: './productivity-kpi.component.html',
  styleUrls: ['./productivity-kpi.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductivityKpiComponent {
  readonly DATE_FORMAT = DateTimeFormat.GermanDateTimeHourFormat;
  @Input() productivity: number | null | undefined;
  @Input() isLoadingProductivity = true;
  @Input() dateRange!: TimelineTimeframe | null;
}
